module.exports = "<div class=q-marg-vert-lg> <div class=q-marg-horz-xl> <div class=\"row q-marg-bottom-md\"> <div class=col-xs-12> <span>By reactivating this team member they will be able to log in and resume all current privileges captured within their profile.</span> </div> </div> <div class=row> <div class=col-xs-12> <span>Do you wish to continue?</span> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/teamMembers/details/sharedHtml/activateModal.html
// module id = 1434
// module chunks = 1